import React from "react";
import { Box, Button } from "@mui/material";

const SwitchAnimace = ({ activeTab, onTabChange, tabs = [] }) => {
  // Default tabs if none provided
  const defaultTabs = [
    { key: "rozehrane", label: "ROZEHRANÉ" },
    { key: "dokoncene", label: "DOKONČENÉ" },
    { key: "nove", label: "NOVÉ" },
  ];

  const tabsList = tabs.length > 0 ? tabs : defaultTabs;

  // Calculate the position and width of the active tab highlight
  const tabIndex = tabsList.findIndex((t) => t.key === activeTab);
  const highlightLeft = `calc(${(tabIndex * 100) / tabsList.length}% + 5px)`;
  const highlightWidth = `calc(${100 / tabsList.length}% - 10px)`;

  return (
    <Box
      sx={{
        position: "relative",
        background:
          "linear-gradient(180deg, rgba(242, 237, 228, 0.2) 0%, rgba(26, 29, 34, 0.4) 40%, rgba(26, 29, 34, 0.6) 60%, #1A1D22 100%), #171A1F",
     //   boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.4)",
        borderRadius: "20px",
        padding: "1px",
        width: "100%",
        maxWidth: "370px",
        mx: "auto",
      }}
    >
      <Box
        sx={{
          background:
            "linear-gradient(180deg, rgba(15, 17, 20, 0) 0%, rgba(15, 17, 20, 0.2) 67.31%), #1A1D22",
          border: "0.5px solid #2F353E",
          borderRadius: "20px",
          padding: "4px",
          display: "flex",
          justifyContent: "space-between",
          gap: "1px",
          position: "relative",
          height: "52px",
        }}
      >
        {/* Animated highlight background */}
        <Box
          sx={{
            position: "absolute",
            left: highlightLeft,
            top: "7px",
            width: highlightWidth,
            height: "44px",
            borderRadius: "17px",
            background:
              "linear-gradient(110.14deg, rgba(26, 29, 34, 0) 0%, rgba(26, 29, 34, 0.2) 49.04%), rgba(127, 150, 188, 0.5)",
            transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
            pointerEvents: "none",
            zIndex: 0,
          }}
        />

        {/* Tab buttons */}
        {tabsList.map((tab) => {
          const isActive = activeTab === tab.key;

          return (
            <Button
              key={tab.key}
              onClick={() => onTabChange(tab.key)}
              disableRipple
              sx={{
                flex: 1,
                position: "relative",
                zIndex: 1,
                color: "#F2EDE4",
                fontFamily: "'Cactus Classical Serif', serif",
                fontSize: "12px",
                letterSpacing: "0.05em",
                textTransform: "uppercase",
                fontWeight: 400,
                textDecoration: "none",
                cursor: "pointer",
                border: "none",
                background: "transparent",
                padding: "10px",
                transition: "color 0.3s ease",
                "&:hover": {
                  color: "#ffffff",
                },
              }}
            >
              {tab.label}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
};

export default SwitchAnimace;
